import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import Asset from "../../../../requests/apa/Asset";

import { PLANSELECTOR } from '../../constants';
import './styles.css';

class RibbonPlanSelector extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.ribbonIndex = props.index;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.history = props.history;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.ribbonType = props.ribbonType ? props.ribbonType : null;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;
    }

    render() {
        return (
            <div className="ribbon-items ribbon-planSelector">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = Math.random() * 10;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: window.location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    let uri = null;

                    uri = node_item.href;

                    const auxRibbonId = this.ribbonId ? this.ribbonId.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase() : ''
                    const auxRibbonType = this.ribbonType ? this.ribbonType.replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase() : ''

                    return (
                        <Card
                            unFocusHandler={this.unFocusHandler}
                            id={index + 1}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ribbonId={this.ribbonId}
                            data={node_item}
                            group_id={node_item.group_id}
                            portrait={Asset.get(`${node_item.banner || ''}`.toLowerCase())}
                            type={PLANSELECTOR}
                            typeRender={this.typeRender}
                            title={node_item.producttype}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.producttype
                                ),
                            }}
                            focusable={true}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}` }
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusHandler={this.focusHandler}
                            setMetricsEvent={this.setMetricsEvent}
                            onClick={() => this.dataUpdateMetrics(dataMetricsRibbon)}
                            clickHandler={this.onClickHandler}
                            href={uri}
                            keyDownHandler={this.keyDownHandler}
                            ribbonName={this.ribbonName}
                            history={this.history}
                            idsRibbonsUpAndDown={this.idsRibbonsUpAndDown}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonPlanSelector;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonPlanSelector/index.jsx